module.exports = __webpack_public_path__ + "static/media/purple-cluster.db55fe2a.svg";